var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0124364 9.73252C0.0795306 9.22966 0.415694 8.80358 0.889504 8.62166L21.3263 0.788926C21.5089 0.719065 21.7129 0.76195 21.8506 0.898213C21.9889 1.03448 22.036 1.23853 21.9696 1.42113L15.4026 19.3955C15.2366 19.8485 14.8672 20.2006 14.4038 20.3417C13.9397 20.4821 13.4354 20.397 13.0453 20.1135L6.90654 15.6465L21.0095 1.75245L5.06042 14.3005L0.569941 11.0329C0.159767 10.7348 -0.0539662 10.2361 0.0124364 9.73252ZM4.03194 15.5949L3.9939 15.3867L9.30126 19.189C9.34414 19.2498 7.75878 20.2888 6.54486 21.0717C6.24328 21.2661 5.86354 21.2965 5.5343 21.1541C5.20505 21.0109 4.96849 20.7141 4.90347 20.36L4.03194 15.5949Z",
    fill: "url(#paint0_linear_244_305)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_244_305",
    x1: 22,
    y1: -2,
    x2: 4,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8764FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A92FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.3cc73e6f2795b66a21f318c76616128c.svg";
export { ForwardRef as ReactComponent };